import React from 'react';
import { connect } from 'react-redux';

import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';

import TopUpMethodList from './TopUpMethodList';

const GaTopUp = (props) => {
    let backUrl = `${AUTH_GA_POCKET}${props.id}`;

    return (
        <CommonPage backUrl={backUrl} showChat={false}>
            <TopUpMethodList />
        </CommonPage>
    );
};
const mapStateToProps = (state) => {
    return {
        id: state.extra.id,
    };
};
export default connect(mapStateToProps, null)(BasePage(GaTopUp));
